import SuggestionCard, { SuggestionCardProps } from './SuggestionCard';

export default SuggestionCard;
export type { SuggestionCardProps };
